import { useMemo, type FC } from "react"
import { Link } from "react-router-dom"

import { alpha, useTheme } from "@mui/material"

import type { DeviceGroupRef } from "types/group.types"

import Chip from "widgets/common/Chip"
import { getColorFromString } from "helpers/utils/styles"
import useRoutes from "helpers/hooks/useRoutes"

interface GroupChipProps {
  group: DeviceGroupRef
}

export const GroupChip: FC<GroupChipProps> = ({ group: { name, id } }) => {
  const theme = useTheme()
  const chipColor = useMemo(() => getColorFromString(name, theme.palette), [name, theme])
  const { baseOrgURL } = useRoutes()

  return (
    <Link to={`${baseOrgURL}/device-groups/${id}`}>
      <Chip
        label={name}
        sx={{
          color: chipColor,
          borderColor: chipColor,
          "&:hover": {
            backgroundColor: alpha(chipColor, 0.1),
          },
          backgroundColor: alpha(chipColor, 0.05),
        }}
      />
    </Link>
  )
}
